define([
    "./workHoursControlModule",
    "./workHoursControlRouter",
    "./workHoursControlService",
    "./search/WorkHoursControlSearchController",
    "./settings/WorkHoursControlSettingsController"
], function () {
});